import * as React from "react";
import { OutlinedInput, InputAdornment, Stack, Avatar, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Panel from "../Panel/panel";
import PanelHeader, { PanelHeaderProps } from "../PanelHeader/panel-header";
import { DbUserBasicInfos } from "../../../Core/Api/Types/db-user-basic-infos";
import { UserAdvancedInfos } from "../../../Core/Api/Types/user-advanced-infos";
import { useTranslation } from "react-i18next";

export interface CustomerUsersPanelProps {
  width?: number;
  open: boolean;
  customerId?: number;
  users: DbUserBasicInfos[] | UserAdvancedInfos[];
  header?: string;
  isAdvancedUser?: boolean;
  onClose?: React.MouseEventHandler;
}

const CustomerUsersPanel: React.FC<CustomerUsersPanelProps> = (props) => {
  const { t } = useTranslation();
  const { onClose, width, open, customerId, users, header, isAdvancedUser = false, ...modalProps } = props;
  const [userSearchPattern, setUserSearchPattern] = React.useState<string>("");

  return (
    <Panel
      header={
        <PanelHeader title={props.header ? props.header : ""} onClose={props.onClose as PanelHeaderProps["onClose"]} />
      }
      open={open}
      onClose={props.onClose}
    >
      <OutlinedInput
        label={t("common:filter")}
        sx={{ width: "100%" }}
        placeholder={t("field:placeholder.filterUsers")}
        onChange={(e) => setUserSearchPattern(e.currentTarget.value)}
        endAdornment={
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        }
      />
      <Stack spacing={1.5} component="ul">
        {props.users
          .map((s) => s.userInfos)
          .filter(
            (x) =>
              userSearchPattern === "" ||
              x.firstName?.toLowerCase().includes(userSearchPattern.toLowerCase()) ||
              x.lastName?.toLowerCase().includes(userSearchPattern.toLowerCase())
          )
          .map((user, index) => (
            <Stack key={index} direction="row" justifyContent="space-between">
              <Stack direction="row" alignItems="center" spacing={1}>
                <Avatar sx={{ width: 36, height: 36 }} />
                <Typography>
                  {user?.firstName}{" "}
                  <Typography component="span" fontWeight={500}>
                    {user?.lastName}
                  </Typography>
                </Typography>
              </Stack>
            </Stack>
          ))}
      </Stack>
    </Panel>
  );
};

export default CustomerUsersPanel;
